import type { Merit } from "../types";

const FIRST_NAME_KEY = "First Name";
const LAST_NAME_KEY = "Last Name";
export const getRecipientFullName = (merit: PickPartial<Merit, "transformedFields">): string =>
  [merit.fieldMap[FIRST_NAME_KEY], merit.fieldMap[LAST_NAME_KEY]].map(str => str.trim()).join(" ");
